<template>
  <v-app id="vapp">
    <div id="app">
      <router-link :to="{ path: '/'}"><img id="logo" alt="H2S logo" src="./assets/logo.svg"></router-link>
      <transition
        name="fade"
        mode="out-in"
      >
        <router-view></router-view>
      </transition>
    </div>
  </v-app>
</template>

<script>
import Dashboard from './components/Dashboard.vue'

export default {
  name: 'app',
  components: {
    appHome: Dashboard
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Kanit:ital,wght@0,100;0,200;0,300;0,400;0,500;0,700;0,800;1,100;1,200;1,300;1,400;1,700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;900&display=swap');

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: Montserrat;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #222;
  margin-top: 0px;
  position: relative;
  height: 100%;
  overflow: hidden;
}
@media (max-width: 768px) {
  overflow: visible;
}
#vapp {
  background-color: #fff;
  /* background: linear-gradient(270deg, #ee9ca7, #ffdde1);
  background-size: 400% 400%;
  animation: sdsd2 15s ease infinite; */
}

.selection-purple {
  background-color: #572C3B;
  color: #fff;
  display: inline-block;
  padding: 0 10px;
}
.selection-pink {
  background-color: #F65996;
  color: #fff;
  display: inline-block;
  padding: 0 10px;
}
.selection-tan {
  background-color: #F5D7CE;
  color: #fff;
  display: inline-block;
  padding: 0 10px;
}
.selection-brown {
  background-color: #BD8574;
  color: #fff;
  display: inline-block;
  padding: 0 10px;
}
.selection-black {
  background-color: #000;
  color: #fff;
  display: inline-block;
  padding: 0 10px;
}
@keyframes float-y-1 {
	0% {
		transform: translateY(0px);
	}
	50% {
		transform: translateY(-20px);
	}
	100% {
		transform: translateY(0px);
	}
}
@keyframes float-y-2 {
	0% {
		transform: translateY(0px);
	}
	50% {
		transform: translateY(20px);
	}
	100% {
		transform: translateY(0px);
	}
}
@keyframes float-x-1 {
	0% {
		transform: translateX(0px);
	}
	50% {
		transform: translateX(-10px);
	}
	100% {
		transform: translateX(0px);
	}
}
@keyframes float-x-2 {
	0% {
		transform: translateX(0px);
	}
	50% {
		transform: translateX(15px);
	}
	100% {
		transform: translateX(0px);
	}
}
@keyframes sdsd2 {
    0% {
      background-position:0% 50%;
    }
    50% {
      background-position:100% 50%;
    }
    100% {
      background-position:0% 50%;
    }
}

img#logo {
  margin-bottom: -15px;
  max-width: 250px;
  margin-top: 40px;
  z-index: 10;
  position: inherit;
}
body {

}
</style>
